module.exports = __webpack_public_path__ + "static/1-78dca315abd725ab0abb618507a2614d.jpg";